import { types } from 'mobx-state-tree'

export const InvoiceNotification = types.model('InvoiceNotification', {
  invoiceId: '',
  date: '',
  phone: '',
  sms: '',
  days: types.maybeNull(types.integer),
})
